import { Relationship } from './graph-data.js'
import * as d3 from 'd3'

export function appendRelationshipToGraph(
  svgRelationships: d3.Selection<SVGGElement, unknown, HTMLElement, any>, // 타입 지정
  relationships: Relationship[],
  options: any
) {
  const relationshipEnter = svgRelationships
    .selectAll<SVGLineElement, Relationship>('.relationship')
    .data(relationships, d => d.id)
    .enter()
    .append('line')
    .attr('class', 'relationship')
    .style('stroke', '#aaa')
    .style('stroke-width', 2)

  return relationshipEnter
}
